import { forwardRef, type SelectHTMLAttributes } from "react";

import "./ui.css";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid = false, className, ...rest },
  ref,
) {
  const classes = ["input", "select", invalid ? "input--invalid" : "", className ?? ""]
    .filter(Boolean)
    .join(" ");
  return <select ref={ref} className={classes} {...rest} />;
});
